import React from 'react';
import { Box } from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';

export const LEGACY_PAGE_WARNING =
  'This page is no longer maintained and will be deprecated in the future. Please use the new Admin UI page going forward. Verify the outcome with a small transaction first.';

export default function LegacyPageBanner() {
  return (
    <Box mt={2}>
      <Alert severity="warning">{LEGACY_PAGE_WARNING}</Alert>
    </Box>
  );
}
